export default __webpack_public_path__ + "locales/cs/ChangePortalOwner.json?hash=3c08cfd62b65d2d57de2086e48cddf28";